import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import { useTranslation } from 'react-i18next'
import TableActions from '../../TableUI/TableActions'
import { Typography } from '@mui/material'
import EditIcon from '@mui/icons-material/Edit'
import { useNavigate } from 'react-router-dom'
import Pagination from '../../Pagination/Pagination'
import TableBackdrop from '../../TableUI/TableBackdrop'
import PreviewIcon from '@mui/icons-material/Preview'
import { METHOD_PROVIDERS__UPDATE } from '../../../enums/Caps'
import useHasPermissions from '../../../hooks/useHasPermissions'


export default function MethodsTable({
    data,
    pages = 1,
    page = 1,
    loading = false,
    handleOnPageChange
}) {
    const { t } = useTranslation()

    const hasPermissions = useHasPermissions()

    const navigate = useNavigate()

    return (
        <>
            <Pagination
                handleOnPageChange={handleOnPageChange}
                page={page}
                pages={pages}
            />

            <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell>{t('Name')}</TableCell>
                            <TableCell>{t('Currency')}</TableCell>
                            <TableCell>{t('Countries')}</TableCell>
                            <TableCell>{t('API URL')}</TableCell>
                            <TableCell align="right">&nbsp;</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {!loading && data.length ? data.map((row) => (
                            <TableRow
                                key={row.id}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            >
                                <TableCell component="th" scope="row">
                                    {row.name}
                                    <Typography variant="subtitle2">
                                        {row.code}
                                    </Typography>
                                </TableCell>
                                <TableCell>{row.provider_currency}</TableCell>
                                <TableCell sx={{
                                    maxWidth: '200px',
                                    wordWrap: 'break-word'
                                }}>{row.countries}</TableCell>
                                <TableCell component="th" scope="row">
                                    {row.api_url}
                                    <Typography variant="subtitle2">
                                        {row.secret_key}
                                    </Typography>
                                </TableCell>
                                <TableCell align="right">
                                    <TableActions actions={[
                                        {
                                            id: `edit-${row.id}`,
                                            handleClick: () => { navigate(`${row.id}/edit`) },
                                            icon: hasPermissions(METHOD_PROVIDERS__UPDATE) ? <EditIcon /> : <PreviewIcon />,
                                            title: hasPermissions(METHOD_PROVIDERS__UPDATE) ? t('Edit') : t('View')
                                        }
                                    ]} />
                                </TableCell>
                            </TableRow>
                        )) : <TableRow>
                            {
                                loading ? <TableBackdrop open={loading} /> : <TableCell sx={{ textAlign: 'center' }} colSpan={100}>{t('No records found')}</TableCell>
                            }
                        </TableRow>
                        }
                    </TableBody>
                </Table>
            </TableContainer>

            <Pagination
                handleOnPageChange={handleOnPageChange}
                page={page}
                pages={pages}
            />
        </>
    )
}
